import request from '@/utils/request'

export function getFloorAndUnits(communityId, skipDataPrivilege = false) {
  const params = { communityId }
  if (skipDataPrivilege) {
    params.skipDataPrivilege = 'Y'
  }
  return new Promise((resolve, reject) => {
    request({
      url: '/floor.queryFloorAndUnits',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}